import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065833e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "td-colon" }, ":", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import {
  ScrollContent,
  ToggleContent,
  ButtonContainer,
  ButtonItem,
  InlineLink,
} from "@/components/modules";
import {
  withDefaults,
  onMounted,
  Ref,
  ref,
} from "vue";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";
import { AttributeView } from "@/attribute/convert/AttributeView";

interface Props {
  attributeConvert: IAttributeConvert;
  buttonDisplay: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'normal-attribute',
  props: {
    attributeConvert: {},
    buttonDisplay: { type: Boolean }
  },
  emits: ["exportCsv", "exportJson", "moveMapToGeometry"],
  setup(__props: any, { emit }) {

const props = __props;




/**
 * 表示データ
 */
const viewFormatData: Ref<AttributeView> = ref(null);

/**
 * 詳細開閉状態
 */
const isOpenToggle = ref(false);

/**
 * 詳細開閉状態更新
 */
const updateIsOpenToggle = (value: boolean) => {
  isOpenToggle.value = value;
};

/**
 * CSV出力
 */
const exportCsv = () => {
  emit("exportCsv", props.attributeConvert);
};

/**
 * JSON出力
 */
const exportJson = () => {
  emit("exportJson", props.attributeConvert);
};

/**
 * 地図を地物の位置へ移動
 */
const moveMapToGeometry = () => {
  const geometry = props.attributeConvert
    .getExportValue()
    .feature.getGeometry();
  emit("moveMapToGeometry", geometry);
};

/**
 * URL判定
 */
const urlTest = (value: string) => {
  return URL.canParse(value);
};

/**
 * 初期処理
 */
onMounted(() => {
  viewFormatData.value = props.attributeConvert?.getViewFormatData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ScrollContent), {
    height: 
      viewFormatData.value?.height && !isOpenToggle.value
        ? viewFormatData.value.height + 'px'
        : viewFormatData.value?.maxheight && isOpenToggle.value
        ? viewFormatData.value.maxheight + 'px'
        : '500px'
    
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(InlineLink), { onClick: moveMapToGeometry }, {
        default: _withCtx(() => [
          _createTextVNode("地物に移動")
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFormatData.value?.attributeValues?.length, (index) => {
        return (_openBlock(), _createElementBlock("table", {
          key: viewFormatData.value.attributeValues[index - 1].key
        }, [
          (
          isOpenToggle.value || viewFormatData.value.attributeValues[index - 1].isSimple
        )
            ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                _createElementVNode("td", null, _toDisplayString(viewFormatData.value.attributeValues[index - 1].key), 1),
                _hoisted_2,
                (
            viewFormatData.value.attributeValues[index - 1].value !== null &&
            viewFormatData.value.attributeValues[index - 1].value !== undefined &&
            urlTest(String(viewFormatData.value.attributeValues[index - 1].value))
          )
                  ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                      _createVNode(_unref(InlineLink), {
                        href: String(viewFormatData.value.attributeValues[index - 1].value),
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(String(viewFormatData.value.attributeValues[index - 1].value)), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(viewFormatData.value.attributeValues[index - 1].value !== null &&
            viewFormatData.value.attributeValues[index - 1].value !== undefined &&
            String(viewFormatData.value.attributeValues[index - 1].value).replaceAll(
              " ",
              ""
            ) !== ""
              ? String(viewFormatData.value.attributeValues[index - 1].value)
              : "-"), 1))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (
        _ctx.buttonDisplay &&
        (isOpenToggle.value ||
          (viewFormatData.value?.attributeValues &&
            !viewFormatData.value.attributeValues.some((ele) => {
              return !ele.isSimple;
            }))) &&
        (!viewFormatData.value?.csvOutputUnPossibility ||
          !viewFormatData.value?.jsonOutputUnPossibility)
      )
        ? (_openBlock(), _createBlock(_unref(ButtonContainer), {
            key: 0,
            align: "left"
          }, {
            default: _withCtx(() => [
              (!viewFormatData.value?.csvOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 0,
                    onClick: exportCsv
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("CSV出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!viewFormatData.value?.jsonOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 1,
                    onClick: exportJson
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("GeoJSON出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        viewFormatData.value?.attributeValues?.some((ele) => {
          return !ele.isSimple;
        })
      )
        ? (_openBlock(), _createBlock(_unref(ToggleContent), {
            key: 1,
            class: "detail-items",
            text: { open: '詳細表示', close: '詳細非表示' },
            onToggle: updateIsOpenToggle
          }))
        : _createCommentVNode("", true),
      (!viewFormatData.value || viewFormatData.value.attributeValues?.length < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 表示対象の属性がありません。 "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["height"]))
}
}

})